import { render, staticRenderFns } from "./CompetitiveBenchmark.vue?vue&type=template&id=c2047194&scoped=true"
import script from "./CompetitiveBenchmark.vue?vue&type=script&lang=js"
export * from "./CompetitiveBenchmark.vue?vue&type=script&lang=js"
import style0 from "./CompetitiveBenchmark.vue?vue&type=style&index=0&id=c2047194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2047194",
  null
  
)

export default component.exports